// ========================================
// 📄 src/hooks/useDashboard.js
// ========================================
import { useState, useEffect, useCallback } from "react";
import { leadService } from "../services/leadService";
import { useAuth } from "../contexts/AuthContext";
import { groupLeadsByStatus, calculateConversionRate } from "../utils/helpers";

export const useDashboard = () => {
  const { currentUser, isAdmin } = useAuth();
  const [stats, setStats] = useState({
    total: 0,
    nouveau: 0,
    contacte: 0,
    qualifie: 0,
    negociation: 0,
    converti: 0,
    perdu: 0,
    conversionRate: 0,
  });
  const [recentLeads, setRecentLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      const leads = isAdmin
        ? await leadService.getAllLeads()
        : await leadService.getLeadsByUser(currentUser.uid);

      const grouped = groupLeadsByStatus(leads);

      setStats({
        total: leads.length,
        nouveau: grouped["nouveau"]?.length || 0,
        contacte: grouped["contacté"]?.length || 0,
        qualifie: grouped["qualifié"]?.length || 0,
        negociation: grouped["en_négociation"]?.length || 0,
        converti: grouped["converti"]?.length || 0,
        perdu: grouped["perdu"]?.length || 0,
        conversionRate: calculateConversionRate(leads),
      });

      setRecentLeads(leads.slice(0, 5));
    } catch (error) {
      console.error("Erreur chargement dashboard:", error);
    } finally {
      setLoading(false);
    }
  }, [currentUser, isAdmin]);

  useEffect(() => {
    if (currentUser) {
      loadDashboardData();
    }
  }, [currentUser, isAdmin, loadDashboardData]);

  return { stats, recentLeads, loading, refetch: loadDashboardData };
};
